import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertTriangle } from 'lucide-react';
const pains = [{
  title: 'El Rostro Mutante',
  description: 'Haces una foto perfecta, pero la siguiente parece otra persona completamente distinta.'
}, {
  title: 'El Look Plástico',
  description: 'Tus modelos parecen muñecos de cera que nadie cree que son reales. Cero textura humana.'
}, {
  title: 'Horas Perdidas',
  description: 'Pasas 4 horas en Discord o Midjourney para sacar una sola foto útil. Un desgaste insostenible.'
}];
export function PainSection() {
  return <section className="py-24 px-5 relative border-t border-white/5 bg-gradient-to-b from-[#0a0a0f] to-[#111118]" data-id="element-158">
      <div className="max-w-4xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-161">
            La Frustración de ser un Creador{' '}
            <span className="text-red-400" data-id="element-162">sin Sistema</span>.
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-163">
            Si sigues dependiendo de la suerte, tu modelo nunca será creíble.
          </p>
        </motion.div>

        <div className="grid gap-6 mb-16" data-id="element-164">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="glass-card p-6 rounded-2xl flex items-start gap-4 border-l-4 border-l-red-500/50 hover:bg-white/[0.02] transition-colors" data-id="element-165">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-166" />
              <div data-id="element-167">
                <h3 className="text-xl font-semibold text-white mb-2" data-id="element-168">
                  {pain.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-169">
                  {pain.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative p-[1px] rounded-2xl bg-gradient-to-r from-red-500/20 via-orange-500/20 to-red-500/20" data-id="element-170">
          <div className="bg-[#111118] p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-171">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-red-500/5 blur-[100px] pointer-events-none" data-id="element-172" />

            <AlertTriangle className="w-10 h-10 text-orange-400 mx-auto mb-4" data-id="element-173" />
            <p className="text-xl md:text-2xl font-medium text-gray-200 leading-relaxed" data-id="element-174">
              "La herramienta no es el problema. El problema es que intentas
              correr antes de saber caminar.{' '}
              <span className="text-white font-bold border-b-2 border-red-500/50" data-id="element-175">
                Estás construyendo sobre arena.
              </span>
              "
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}